import { render } from "./dateOnly.vue?vue&type=template&id=204d111c"
import script from "./dateOnly.vue?vue&type=script&lang=js"
export * from "./dateOnly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__